var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6001 16.3538L17.8731 9.08079L16.3693 7.57696L10.6001 13.3462L7.70007 10.4462L6.19625 11.95L10.6001 16.3538ZM5.3078 21.15C4.62391 21.15 4.04333 20.9113 3.56605 20.434C3.08875 19.9568 2.8501 19.3762 2.8501 18.6923V5.30774C2.8501 4.62385 3.08875 4.04327 3.56605 3.56599C4.04333 3.08869 4.62391 2.85004 5.3078 2.85004H18.6923C19.3762 2.85004 19.9568 3.08869 20.4341 3.56599C20.9114 4.04327 21.15 4.62385 21.15 5.30774V18.6923C21.15 19.3762 20.9114 19.9568 20.4341 20.434C19.9568 20.9113 19.3762 21.15 18.6923 21.15H5.3078ZM5.3078 19H18.6923C18.7693 19 18.8398 18.968 18.9039 18.9039C18.968 18.8397 19.0001 18.7692 19.0001 18.6923V5.30774C19.0001 5.2308 18.968 5.16028 18.9039 5.09616C18.8398 5.03206 18.7693 5.00001 18.6923 5.00001H5.3078C5.23086 5.00001 5.16034 5.03206 5.09622 5.09616C5.03212 5.16028 5.00007 5.2308 5.00007 5.30774V18.6923C5.00007 18.7692 5.03212 18.8397 5.09622 18.9039C5.16034 18.968 5.23086 19 5.3078 19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChecked);
export default __webpack_public_path__ + "static/media/icon-checked.5aea8a20eadcfa879d30e2288d94f71d.svg";
export { ForwardRef as ReactComponent };